import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";

const sleep = milliSec => {
  return new Promise(resolve => setTimeout(resolve, milliSec));
};

const makeRandomText = (type, length) => {
  const alphabetList = {
    little: "abcdefghijklmnopqrstuvwxyz0123456789",
    big: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
  };
  let returnStr = "";

  for (let i = 0; i < length; i++) {
    const index = Math.floor(Math.random() * alphabetList[type].length);
    returnStr = returnStr + alphabetList[type][index];
  }

  return returnStr;
};

const getGradationCss = colorObj => {
  return `linear-gradient(.25turn,${colorObj.start},${colorObj.end})`;
};

const isEmpty = value => {
  if (
    value === "" ||
    value === null ||
    value === undefined ||
    (value !== null && typeof value === "object" && !Object.keys(value).length)
  ) {
    return true;
  } else {
    return false;
  }
};

const deepCopyObject = inputObj => {
  return cloneDeep(inputObj);
};

const isSameObject = (inputObj1, inputObj2) => {
  return isEqual(inputObj1, inputObj2);
};

const removeUndefinedFromObject = obj => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

const getAge = (year, month, day) => {
  /**
   * 만나이 출력.
   */
  if (
    typeof year !== "number" ||
    typeof month !== "number" ||
    typeof day !== "number"
  ) {
    throw Error(
      `wrong date input : year:"${year}", year:"${month}", year:"${day}"`
    );
  }

  const today = new Date();
  const birthDate = new Date(year, month - 1, day);

  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

const getLangType = viewerLocation => {
  switch (viewerLocation) {
    case "RU":
    case "JP":
    case "IT":
    case "ES":
    case "DE":
    case "CN":
    case "FR":
    case "KR":
    case "GB":
    case "CA":
    case "US":
      return `l_${viewerLocation.toLowerCase()}`;
    case null:
      return "l_us";
    default:
      return "l_us";
  }
};

const removeSpaceFromText = inputStr => {
  /**
   * - 모든 2칸이상의 공백을 1개로 축소
   * - 모든 2줄이상의 공백을 1줄로 축소
   * - 모든 줄의 앞 뒤 공백 제거
   * - 문장 시작과 끝의 빈 줄바꿈 제거
   */
  if (typeof inputStr !== "string") return inputStr;

  // 1) CRLF 등을 \n으로 통일
  let text = inputStr.replace(/\r\n/g, "\n").replace(/\r/g, "\n");

  // 2) 각 줄의 연속 공백(2칸 이상)을 1칸으로
  // 3) 각 줄의 앞뒤 공백 제거
  text = text
    .split("\n")
    .map(line => line.replace(/ {2,}/g, " ").trim())
    .join("\n");

  // 4) 연속된 줄바꿈(\n)이 2회 이상이면 \n\n으로 축소
  text = text.replace(/\n{3,}/g, "\n\n");

  // 5) 전체 문자열의 맨 처음에 있는 모든 줄바꿈(\n) 제거
  //    그리고 맨 끝에 있는 모든 줄바꿈(\n) 제거
  text = text.replace(/^\n+/, "").replace(/\n+$/, "");

  return text;
};

export {
  sleep,
  makeRandomText,
  getGradationCss,
  isEmpty,
  deepCopyObject,
  isSameObject,
  removeUndefinedFromObject,
  getAge,
  getLangType,
  removeSpaceFromText
};
